export default __webpack_public_path__ + "static/media/ios_step_2_En.36cd63bc.jpg";